import React from 'react';
import { LogOut } from 'lucide-react';

export default function LogoutModal({
    showLogoutModal,
    setShowLogoutModal,
    handleLogout
}) {
    return (
        showLogoutModal && (
            <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[150] p-4">
                <div className="bg-gray-800 border border-gray-700 rounded-2xl p-6 max-w-md w-full">
                    <div className="flex items-center space-x-3 mb-4">
                        <div className="w-12 h-12 bg-red-500/20 rounded-xl flex items-center justify-center">
                            <LogOut className="w-6 h-6 text-red-400" />
                        </div>
                        <div>
                            <h3 className="text-lg font-semibold text-white">Logout Confirmation</h3>
                            <p className="text-gray-400 text-sm">Are you sure you want to logout?</p>
                        </div>
                    </div>

                    <div className="flex space-x-3 mt-6">
                        <button
                            onClick={() => setShowLogoutModal(false)}
                            className="flex-1 py-2 bg-gray-700 hover:bg-gray-600 text-gray-300 rounded-lg font-medium transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleLogout}
                            className="flex-1 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg font-medium transition-colors"
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        )
    );
} 